<template>
    <div class="information">
        <div class="info-top">
            <div class="personal-information">
                <div class="head-portrait">
                    <i :class="{'icon-male':$store.state.currentUser && $store.state.currentUser.smartGender == 1,'icon-female': $store.state.currentUser && $store.state.currentUser.smartGender == 2}" class="iconfont"></i>
                </div>
                <div class="detailed-information">
                    <div class="user-name">
                        {{$store.state.currentUser != null ? ($store.state.currentUser.name ? $store.state.currentUser.name : null) : null}}
                    </div>
                    <div class="account-number">
                        {{$store.state.currentUser != null ? ($store.state.currentUser.uid ? $store.state.currentUser.uid : null) : null}}
                    </div>
                    <i :class="{'icon-nan':$store.state.currentUser && $store.state.currentUser.smartGender == 1,'icon-nv': $store.state.currentUser && $store.state.currentUser.smartGender == 2}" class="iconfont"></i>
                    <!-- <i class="iconfont" :class="{'icon-male':$store.state.currentUser && $store.state.currentUser.smartGender == 1,'icon-female': $store.state.currentUser && $store.state.currentUser.smartGender == 2}"></i><br/>
                    <i class="iconfont icon-dingwei"></i>
                    <div class="user-address">北京，重庆，香港，乌鲁木齐</div><a href="#">修改</a><i class="iconfont icon-xiangxia"></i><br/>
                    <i class="iconfont icon-yuyan-kong"></i>
                    <el-select v-model="languageDefult" suffix-icon="el-icon-caret-bottom" size="mini">
                        <el-option v-for="i in language" :key="i.flag" :label="i.language" :value="i.flag"></el-option>
                    </el-select> -->
                </div>
            </div>
            <!-- <div class="account-information">
                <div class="pass-time">
                    <i class="iconfont icon-date-2"></i><div class="account-desc">密码时效（天）</div><div class="account-day">365</div>
                </div>
                <div class="account-security">
                    <i class="iconfont icon-anquan"></i><div class="security-desc">账号安全</div>
                    <el-rate
                        v-model="rate"
                        show-text
                        disabled
                        :texts="rateText">
                    </el-rate>
                </div>
            </div> -->
        </div>
        <div class="info-down">
            <header>账号信息 <el-button type="primary" @click="backHome" size="mini" plain style="float: right; margin-top:16px;width: auto;">返回门户首页</el-button></header>
            <!-- <div>
                <div class="info-down-tips"><i class="iconfont icon-shijian"></i>登录时间</div>
                <div class="info-down-desc">上次登录时间：2018-10-08 13:42:32（GMT + 8:00）</div>
                <div class="info-down-status"><i class="iconfont icon-chenggong"></i><span>正常<span>|</span><a href="#">查看</a></span></div>
            </div> -->
            <!-- <div>
                <div class="info-down-tips"><i class="iconfont icon-iconzh1"></i>账号时效</div>
                <div class="info-down-desc">账户过期时间：2017.09.16 17:00:03</div>
                <div class="info-down-status"><i class="iconfont icon-chenggong"></i><span>未过期<span>|</span><a href="#">延期</a></span></div>
            </div> -->
            <div>
                <div class="info-down-tips"><i class="iconfont icon-mima"></i>登录密码</div>
                <div class="info-down-desc">密码过期时间 {{$store.state.currentUser && ($store.state.currentUser.passwordExpirationTime != null ? '：'+$store.state.currentUser.passwordExpirationTime : '-')}}</div>
                <div class="info-down-status"><i class="iconfont" :class="{'icon-chenggong':!$store.state.overdue,'icon-jinggao2':$store.state.overdue}"></i><span>{{$store.state.overdue ? '已过期' : '未过期'}}<span>|</span><a  @click="link( '/updatePassword' )">修改</a></span></div>
                <!-- <div class="info-down-status"><i class="iconfont icon-jinggao2"></i><span>{{$store.state.overdue ? '已过期' : '未过期'}}<span>|</span><a  @click="link( '/updatePassword' )">修改</a></span></div> -->
            </div>
            <!-- <div>
                <div class="info-down-tips"><i class="iconfont icon-shouji"></i>手机</div>
                <div class="info-down-desc">
                    {{$store.state.currentUser != null ? ($store.state.currentUser.mobile != null && $store.state.currentUser.mobile != '' ? $store.state.currentUser.mobile : '您未绑定手机') : '您未绑定手机'}}
                </div>
                <div v-if="$store.state.currentUser == null || $store.state.currentUser.mobile == null || $store.state.currentUser.mobile == ''" class="info-down-status" :class="{'info-down-warning': iconStatus}"><i class="iconfont" :class="{'icon-chenggong':!iconStatus,'icon-jinggao2':iconStatus}"></i><span>未设置<span>|</span><a @click="link( '/bindingCellPhone' )">绑定</a></span></div>
                <div v-else class="info-down-status"><i class="iconfont icon-chenggong"></i><span>已设置<span>|</span><a  @click="link( '/bindingCellPhone' )">修改</a></span></div>
            </div> -->
        </div>
    </div>
</template>

<script>
import http from '../utils/httpClient'
export default {
    components: {
        
    },
    computed: {
        userInfo () {
            return this.$store.state.currentUser
        }
    },
    name: 'information',
    data () {
        return {
            // headPortrait: true,
            // languageDefult: 'zh-Cn',
            // language: [{language:'简体中文',flag:'zh-Cn'},{language:'English',flag:'us-En'},{language:'日本语',flag:'Jp'}],
            // rate: 3,
            // rateText:['极低','低','中','高','极高'],
            iconStatus: true,
            overdue: '未过期',
        }
    },
    methods: {
        link( route ){
            // var router = this.$store.state.routerData;
            // for( var i in router ){
            //     if( router[i].url.indexOf( route ) > -1 ){
            //         break;
            //     }else if( router[i].url.indexOf( route ) < 0 ){
            //         switch( route ){
            //             case '/updatePassword':
            //                 router.push({ name: '修改登录密码', url: route });
            //             break;
            //             case '/bindingCellPhone':
            //                 router.push({ name: '绑定手机', url: route });
            //             break;
            //             case '/setInsurance':
            //                 router.push({ name: '设置密保', url: route });
            //             break;
            //         }
            //     }
            // }
            // this.$router.push( {path: route} );

            // var routeArr = [];
            // if (route == '/updatePassword') {
            //     routeArr.push({ name: '安全设置', url: '/securitySetting' }, { name: '修改登录密码', url: route });
            // } else if (route == '/bindingCellPhone') {
            //     routeArr.push({ name: '安全设置', url: '/securitySetting' }, { name: '绑定手机', url: route });
            // } else if (route == '/setInsurance') {
            //     routeArr.push({ name: '安全设置', url: '/securitySetting' }, { name: '设置密保', url: route });
            // }
            // this.$store.commit('routerData',Array.from(new Set(routeArr)));
            const smartType = this.userInfo.smartType
            if ( smartType === '0' && route === '/bindingCellPhone') {
                window.open( process.env.HRURL )
            }
            else {
                this.$router.push( {path: route} );
            }
        },
        backHome() {
            let url = `${process.env.HomeUrl}`
            window.open(url, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.information{
    width: 100%; height: 100%; overflow: hidden; display: flex; flex-direction: column;
    .info-top{
        height: 146px; width: 100%; margin-bottom: 16px; background: #ffffff; background: url(../../static/oval.png) no-repeat center; background-size: 100%; padding: 20px; padding-left: 60px; border: 1px solid #e8e8e8;
        .personal-information{
            float: left; width: 55%; height: 100%; display: flex; align-items: center;
            .head-portrait{
                width: 70px; height: 70px; border: 2px solid #ffffff; border-radius: 50%; line-height: 70px; text-align: center; overflow: hidden;
                i{
                    font-size: 65px; color: #5c5b5b;
                }
            }
            .detailed-information{
                padding-left: 25px; line-height: 28px;
                .user-name{
                    font-weight: 600; font-size: 20px; display: inline-block;
                }
                .account-number{
                    font-size: 14px; margin: 0 10px; display: inline-block;
                }
                .icon-nv{
                    color: #FF71C4;
                }
                .icon-xiangxia{
                    font-size: 12px; color: #77839F;
                }
                .icon-dingwei{
                    font-size: 14px; color: #77839F;
                }
                .icon-yuyan-kong{
                    color: #77839F;
                }
                .user-address{
                    margin: 0 5px; display: inline-block;
                }
                a{
                    color: #3AA2EB; text-decoration: none;
                }
            }
        }
        .account-information{
            float: right; width: 45%; height: 100%; display: flex; justify-content: space-evenly; align-items: center; line-height: 35px; text-align: center; position: relative;
            .icon-date-2,.icon-anquan{
                color: #75B034;
            }
            .account-desc,.security-desc{
                font-size: 16px; color: #666666; display: inline-block; margin-left: 7px;
            }
            .account-day{
                font-size: 22px; font-weight: 600;
            }
            &::before{
                position: absolute;
                left: 0;
                content: '';
                height: 60px;
                border-left: 1px solid #cccccc;
            }
        }
    }
    .info-down{
        flex: 1; overflow: hidden; background: #ffffff; width: 100%; border: 1px solid #e8e8e8;
        header{
            height: 60px; line-height: 60px; border-bottom: 1px solid #e8e8e8; padding: 0 20px; font-size: 16px;
        }
        div{
            border-bottom: 1px solid #e8e8e8; height: 80px; line-height: 80px; margin: 0 20px; display: flex; justify-content: space-between; align-items: center;
            .info-down-tips{
                font-size: 14px;
                i{
                    color: #77839F; margin-right: 10px; font-size: 18px;
                }
            }
            .info-down-desc{
                font-size: 12px; color: #8391AF; min-width: 360px; margin-left: -170px;
            }
            .info-down-status{
                font-size: 12px; margin-right: 80px; color: #75B035; min-width: 111px; text-align: right; display: flex; align-items: baseline; justify-content: flex-end;
                span{
                    margin: 0 8px;
                    span{
                        color: #d8d8d8;
                    }
                    a{
                        color: #148EF5; text-decoration: none;cursor: pointer;
                    }
                }
                i{
                    font-size: 16px;
                }
            }
            .info-down-warning{
                color: #FAA51F;
            }
            .icon-jinggao2 {
                color: #FAA51F;
            }
        }
    }
    /* 性别为男的图标颜色 */
    .iconfont.icon-nan {
        color: #3AA2EB;
        font-size: 18px;
    }
}
</style>
<style>
.detailed-information .el-select .el-input input{
    background: transparent; border: none; padding-left: 0px; color: black;
}
.detailed-information .el-select{
    width: 78px;
}
.account-security .el-rate{
    height: 35px;
}
.account-security .el-rate__text{
    font-size: 22px; font-weight: 600; line-height: 35px; color: #FAA51F!important;
}
.account-security .el-rate .el-rate__icon{
    font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/information.vue